export default __webpack_public_path__ + "./images/hr.67425fc1.png";